import * as React from 'react';
import { SheLocation } from '../../../types/location';
import { observer } from 'mobx-react';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import HeaderImagePc from './images/homebase_popup_bg-pc.png';
import HeaderImageSp from './images/homebase_popup_bg-sp.png';
import './homeLocationPopUp.module.scss';
import { HomeLocationSelector } from './HomeLocationSelector';
import { LocationId } from '../../../../commonv3/types/locations';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';

type Props = {
  locations: SheLocation[];
  selectedLocationId: LocationId;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSelect: (locationId: LocationId) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onRequestClose: () => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSubmit: () => any;
  loading: boolean;
};

export const HomeLocationPopUp = observer(
  ({ locations, selectedLocationId, onSelect, onRequestClose, onSubmit, loading }: Props) => {
    const sp = GlobalStatesV3.viewport.isSp;
    return (
      <div styleName="popup">
        {sp ? <img src={HeaderImageSp} styleName="header-img" /> : <img src={HeaderImagePc} styleName="header-img" />}
        <div styleName="body">
          <div styleName="body-header">- 最も多く利用する拠点（ホーム拠点）を教えて下さい -</div>
          <div styleName="body-sub-header">
            ※ホーム拠点はマイページからいつでも変更することができます
            <br />※<span styleName="bold">どの拠点を選んでいただいても全ての拠点を利用することができます</span>
          </div>
          <div styleName="selector-wrapper">
            <HomeLocationSelector
              currentLocationOnline={false}
              selectedLocationId={selectedLocationId}
              onSelect={onSelect}
              locations={locations}
            />
          </div>
          <div styleName="button-wrapper">
            <Button
              id="home-location-submit"
              type="primary"
              size="l"
              styleName="button"
              disabled={selectedLocationId != null && selectedLocationId <= 0}
              onClick={onSubmit}
              loading={loading}
            >
              この内容で登録する
            </Button>
            <Button type="normal" size="l" styleName="button" onClick={onRequestClose} loading={loading}>
              あとで登録する(閉じる)
            </Button>
          </div>
        </div>
      </div>
    );
  }
);
